import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'


function UnuversalDropDown(props) {
    const dispatch = useDispatch()

    const typeObject = useSelector(props.selectFunc)

    const [showDropDown, setShowDropDown] = useState(false);

    const handleClickDropDown = () => {
        console.log('handleClickDropDown')
        setShowDropDown(!showDropDown)
    }

    function handleClickObject(index) {
        dispatch(props.setFunc(props.listOf[index].label))
        setShowDropDown(false)
    }

    return (
                <div className="form-group">
                    <div className="">
                        <label for="select-1" className="section-two-banks-text-2">{props.title}</label>
                        <button onClick={handleClickDropDown} className="dropdown__button pole pole-step-2">{typeObject}</button>
                        {showDropDown &&
                            <ul className="dropdown__list over_scroll_x">
                                {
                                    props.listOf.map((object, index) => {
                                        return (
                                            <li
                                                key={index}
                                                class="dropdown__list-item"
                                                onClick={() => handleClickObject(index)}
                                            >
                                                {object.label}
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }
                        {/* <input type="text" name="select-category" value=""
                                        class="dropdown__input-hidden" /> */}
                    </div>
                </div>
    );
}

export default UnuversalDropDown;